import { render } from "./ModalEditAttribute.vue?vue&type=template&id=53dfd296"
import script from "./ModalEditAttribute.vue?vue&type=script&lang=js"
export * from "./ModalEditAttribute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__